import React, { useRef } from "react";
import cx from "classnames";

const AnimatedSection = ({ isOpened, sectionContent }) => {
  const ref = useRef(null);
  const shouldTitleLeft = (title) =>
    title.trim().charAt(title.length - 1) === ":";

  return (
    <div
      style={{
        maxHeight: isOpened ? ref.current.offsetHeight + "px" : "0",
        transition: "all .2s ease-out",
      }}
      className="overflow-hidden"
    >
      <div ref={ref} className="flex justify-around flex-wrap">
        {sectionContent &&
          sectionContent.map((content) => (
            <div key={content.id} className="w-full">
              {content.title && (
                <div
                  className={cx(
                    "mt-3 mb-2 font-bold agrandir text-md sm:text-lg text-purple-800",
                    {
                      "ml-5": shouldTitleLeft(content.title),
                      "text-center": !shouldTitleLeft(content.title),
                    }
                  )}
                >
                  {content.title}
                </div>
              )}
              <div className="ml-5 mr-2 mb-3 text-black text-md sm:text-lg agrandir leading-normal">
                {content.body}
                {content.points && (
                  <ul
                    className="pt-3"
                    style={{ listStyle: "disc", paddingLeft: "30px" }}
                  >
                    {content.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default AnimatedSection;
